import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../../constants';

export interface TrackingUnit {
  riderId: number;
  riderName: string;
  riderPhoneNumber?: string;
  assignedPhoneNumber?: string;
  vehicleId?: number;
  vehiclePlateNumber?: string;
  trackingId?: string;
  status: string;
  latitude: number;
  longitude: number;
  accuracyMeters?: number;
  batteryLevel?: number;
  recordedAt?: string;
  source: string;
  isStale: boolean;
  positionX: number;
  positionY: number;
}

export interface TrackingDashboard {
  liveUnits: number;
  staleUnits: number;
  offlineUnits: number;
  activeTrips: number;
  units: TrackingUnit[];
}

@Injectable({ providedIn: 'root' })
export class TrackingService {
  private baseUrl = `${baseUrl}LogisticsTracking`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
  }

  getDashboard(): Observable<TrackingDashboard> {
    return this.http.get<TrackingDashboard>(`${this.baseUrl}/dashboard`, this.headers);
  }

  createPing(payload: any): Observable<TrackingUnit> {
    return this.http.post<TrackingUnit>(`${this.baseUrl}/ping`, payload, this.headers);
  }
}
